import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    commonTitleList: [],
  },
  getters: {
    commonTitleList: (state) => state.commonTitleList,
  },
  mutations: {
    setCommonTitleList(state, list) {
      state.commonTitleList = list;
    },
  },
  actions: {},
  modules: {},
});
